export enum SearchFilter {
  PEOPLE = 'people',
  EVENTS = 'events',
}

export function getSearchFilterName(filter: SearchFilter): string {
  switch (filter) {
    case SearchFilter.PEOPLE:
      return 'People';
    case SearchFilter.EVENTS:
      return 'Events';
  }
}
